import { render, staticRenderFns } from "./PenNibIcon.vue?vue&type=template&id=06b157f4&"
import script from "./PenNibIcon.vue?vue&type=script&lang=js&"
export * from "./PenNibIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports